import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/query/queryKeys'
import { disconnectConnection } from '@/services/integrations'

/**
 * Disconnect an app.
 *
 * No optimistic removal: the row disappearing before the server confirms would
 * tell the user an app is disconnected when it may still be live. Reconcile
 * from the server instead.
 */
export function useDisconnectApp() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ connectionId }) => disconnectConnection({ connectionId }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['integrations', 'connections'] })
    },
  })
}
